import { PreferencesKey } from '@/data/dal/preferencesKey';

import { useDAL } from './useDAL';
import { useEnvironment } from './useEnvironment';
import { useUser } from './useUser';

export const useIsDevModeEnabled = () => {
  const dal = useDAL();
  const { isDemo } = useEnvironment();
  const { isEmployee } = useUser();
  const { data: prefResponse } = dal.preferences.useUserPref(
    PreferencesKey.Preferences
  );

  return Boolean(isEmployee && !isDemo && prefResponse?.value?.isDevMode);
};
